import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router";
import { Tab, Tabs } from "react-bootstrap";

import { text } from "../../../constants/text";

import DetaljPageHeader from "../../Common/Detalj/DetaljPageHeader";
import ButtonsContainer from "./ButtonsContainer";
import IleggelseGridOgKommentarContainer from "../../Common/Ileggelser/Detalj/IleggelseGridOgKommentarContainer";
import TilbakemeldingerFraBybetjenterContainer from "../../Common/Ileggelser/Detalj/TilbakemeldingerFraBybetjenterContainer";
import BilderContainer from "../../Common/Ileggelser/Detalj/BilderContainer";
import BilderButtonsContainer from "./BilderButtonsContainer";
import Ettersendelser from "../../Common/Ileggelser/Detalj/Ettersendelser";
import NyeEttersendelser from "../../Common/Ileggelser/Detalj/NyeEttersendelser";
import KlageinformasjonContainer from "../../Common/Ileggelser/Detalj/KlageinformasjonContainer";
import SystemloggContainer from "./SystemloggContainer";
import MakuleringsarsakContainers from "./MakuleringsarsakContainer";
import HistorikkOgKommentarerContainer from "./HistorikkOgKommentarerContainer";
import Map from "../../Common/Maps/MapView";
import Spinner from "../../Common/Spinner";

import { getIleggelse } from "../../../actions/ileggelserActions";
import { getIleggelseEttersendelser } from "../../../actions/ileggelseEttersendelserActions";
import { getBybetjenter } from "../../../actions/bybetjenterActions";

import * as title from "../../../constants/titles";

import "./IleggelseDetaljPage.css";
import KlagebehandlingInformasjonContainer from "../../../components/Common/Ileggelser/Detalj/KlagebehandlingInformasjonContainer";

export default function IleggelseDetaljPage() {
  const dispatch = useDispatch();
  const params = useParams();
  const id = params.id;
  const ileggelse = useSelector((state) => state.ileggelse);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = title.ileggelseDetalj();
    dispatch(getIleggelse(id))
      .then((result) => {
        document.title = title.ileggelseDetalj(result.ileggelsesnummer);
      })
      .catch(() => (document.title = title.ileggelseDetalj()));
    dispatch(getIleggelseEttersendelser(id));
    dispatch(getBybetjenter({ onlyActive: false }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (ileggelse && ileggelse.id === id) {
    return (
      <div className="ileggelse-content-wrapper">
        <DetaljPageHeader
          pageName={text.ileggelseGebyr.pageName}
          pageId={String(ileggelse.ileggelsesnummer)}
          isMakulert={ileggelse.isMakulert}
          computedMatch={{ params }}
        />
        <Tabs id="tabs-ileggelse-kart" className="detailjTab" mountOnEnter>
          <Tab eventKey={1} title="Ileggelse">
            <div className="ileggelse-tab-content-wrapper">
              <ButtonsContainer ileggelseId={id} />
              <IleggelseGridOgKommentarContainer />
              <TilbakemeldingerFraBybetjenterContainer ileggelseId={id} />
              <BilderContainer
                ileggelseId={id}
                BilderButtonsContainer={BilderButtonsContainer}
                checkbox
              />
              <Ettersendelser />
              <NyeEttersendelser />
              <KlageinformasjonContainer ileggelseId={id} />
              <KlagebehandlingInformasjonContainer ileggelseId={id} />
              <SystemloggContainer ileggelseId={id} />
              <MakuleringsarsakContainers />
              <HistorikkOgKommentarerContainer ileggelseId={id} />
            </div>
          </Tab>
          <Tab eventKey={2} title="Kart">
            <div className="ileggelse-tab-content-wrapper">
              <Map lat={ileggelse.latitude} lng={ileggelse.longitude} />
            </div>
          </Tab>
        </Tabs>
      </div>
    );
  }
  return (
    <div>
      <Spinner isLoading />
    </div>
  );
}
